module.exports = __webpack_public_path__ + "static/media/1.391aa984.png";